// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2wYXk","inner":"Form_inner__1XDL-","range":"Form_range__1u3FQ","name":"Form_name__33Lcz","actions":"Form_actions__19EAz"};